export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Patel',
    role: 'Warehouse Owner',
    company: 'Ahmedabad',
    avatar: 'RP',
    rating: 5,
    quote:
      'We purchased a Hydraulic Goods Lift from Aavjo Industries and the quality is outstanding. Smooth lifting, strong structure, and excellent safety features.',
  },
  {
    id: 2,
    name: 'Amit Sharma',
    role: 'Factory Supervisor',
    company: 'Surat',
    avatar: 'AS',
    rating: 5,
    quote:
      'The Scissor Lift platform is very stable and easy to operate. Perfect for our factory maintenance work and high-level operations.',
  },
  {
    id: 3,
    name: 'Vikram Singh',
    role: 'Logistics Manager',
    company: 'Vadodara',
    avatar: 'VS',
    rating: 5,
    quote:
      'We are using the Electric Stacker daily in our warehouse. Smooth movement, reliable battery backup, and very low maintenance.',
  },
  {
    id: 4,
    name: 'Deepak Verma',
    role: 'Warehouse Operator',
    company: 'Rajkot',
    avatar: 'DV',
    rating: 5,
    quote:
      'The Hand Pallet Truck quality is excellent and works perfectly for heavy pallet movement in our dispatch area.',
  },
  {
    id: 5,
    name: 'Karan Mehta',
    role: 'Industrial Buyer',
    company: 'Ahmedabad',
    avatar: 'KM',
    rating: 5,
    quote:
      'The Electric Pallet Truck improved our warehouse productivity significantly. Easy controls and smooth handling.',
  },
  {
    id: 6,
    name: 'Neeraj Kumar',
    role: 'Logistics Company',
    company: 'Indore',
    avatar: 'NK',
    rating: 5,
    quote:
      'Aavjo Industries provided us with a customized Dock Leveller solution for our loading bay. Performance and build quality are excellent.',
  },
  {
    id: 7,
    name: 'Harshad Joshi',
    role: 'Workshop Owner',
    company: 'Pune',
    avatar: 'HJ',
    rating: 5,
    quote:
      'The Floor Crane is very strong and easy to maneuver. Perfect for machine shifting and industrial lifting applications.',
  },
  {
    id: 8,
    name: 'Rakesh Yadav',
    role: 'Packaging Industry',
    company: 'Jaipur',
    avatar: 'RY',
    rating: 5,
    quote:
      'We installed the Roller Conveyor system in our packaging unit and it made our material movement much faster and more efficient.',
  },
  {
    id: 9,
    name: 'Manish Shah',
    role: 'Maintenance Contractor',
    company: 'Ahmedabad',
    avatar: 'MS',
    rating: 5,
    quote:
      'The Aerial Work Platform is stable, safe, and ideal for maintenance work at height. Excellent industrial equipment.',
  },
  {
    id: 10,
    name: 'Sandeep Chauhan',
    role: 'Production Manager',
    company: 'Mumbai',
    avatar: 'SC',
    rating: 5,
    quote:
      'Aavjo Industries is a trusted supplier for material handling equipment. Their products are durable, reliable, and built for industrial performance.',
  },
];
